<div class="flex items-center justify-center p-4 text-center">
  <span class="text-sm text-neutral-600">{{
    'pages.home.noSearchResults' | translate
  }}</span>
</div>
